module.exports = __webpack_public_path__ + "img/9.2dc1d65a.jpg";